class SiteData {
    title:string = 'React';
    siteLanguage: string = "React";
    fightImage:string = '/images/react-fight-image.png';
    fightImageWidth:number = 400;
    onlineCompilerUrl='';
}

export default SiteData;